





































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDevicePinedMessage from '@/components/builder/BuilderDevicePinedMessage.vue'
import BuilderDeviceChatsPreviewMessageStub from '@/components/builder/BuilderDeviceChatsPreviewMessageStub.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderDeviceFooterStub from '@/components/builder/BuilderDeviceProfileFooterStub.vue'
import BuilderDeviceChatPreviewHeader from '@/components/builder/BuilderDeviceChatPreviewHeader.vue'
import BuilderDevicePreviewFooter from '@/components/builder/BuilderDevicePreviewFooter.vue'

export interface Messages {
  id: number
  title: string
  image: File | string | null
}

@Component({
  components: {
    BuilderDevicePreviewFooter,
    BuilderDeviceChatPreviewHeader,
    BuilderDeviceFooterStub,
    BuilderDevice,
    BuilderDeviceChatsPreviewMessageStub,
    BuilderDevicePinedMessage,
  },
})
export default class BuilderDeviceChatsPreviewStub extends Vue {
  @Prop({ required: true, type: Array }) messages!: Messages[]

  @Prop({ default: false, type: Boolean }) viewMode!: boolean
}
